export default __webpack_public_path__ + "static/image3-e73e11252608041bdbb3f87289bd843c.png";